<template>
  <div class="">
    <el-row :gutter="20">
      <el-col :span="6">
        <div>
          <el-input
            v-model="key"
            placeholder="请输入关键字或词"
            class="input-with-select"
            size="small"
            suffix-icon="el-icon-search"
          />
        </div>
      </el-col>
      <el-col :span="18" class="btn">
        <div >
          <el-button @click="onClick" type="primary" size="small">服务时长配置</el-button>
          <el-button
            v-if="leftData.length"
            type="primary"
            icon="el-icon-download"
            size="small"
            @click="handelInfo"
            v-permission="['通知管理导入']"
            >导入通知</el-button
          >
        </div>
      </el-col>
    </el-row>
    <div class="container-table">
      <el-table
        ref="filterTable"
        v-loading="loading"
        stripe
        size="mini"
        :data="infoData"
        style="width: 100%"
        border
        :cell-style="cellStyle"
        :header-cell-style="tableHeaderColor"
      >
        <el-table-column type="index" width="80" label="通知编号" />
        <el-table-column prop="name" label="通知名称">
          <template slot-scope="scope">
            <div style="font-size: 12px">{{ scope.row.name }}</div>
          </template>
        </el-table-column>
        <el-table-column label="通知方式">
          <template slot-scope="scope">
            <span>{{ pinjieMethod(scope.row.method) }}</span>
            <!--<span v-for="(i, index) in scope.row.method" :key="index">-->
            <!--<span>{{ i }}、</span>-->
            <!--</span>-->
          </template>
        </el-table-column>
        <el-table-column label="通知角色">
          <template slot-scope="scope">
            <span>{{ pinjie(scope.row.receiver_role_list) }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <el-link
              type="primary"
              :underline="false"
              class="edit"
              @click="editInfo(scope.row)"
              v-permission="['通知管理编辑']"
              >编辑</el-link
            >
            <el-link
              type="primary"
              :underline="false"
              class="edit"
              style="font-size: 12px"
              v-permission="['通知管理删除']"
              @click="deleteInfo(scope.row)"
              >删除</el-link
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--分页-->
    <div class="pages">
      <el-pagination
        samll
        background
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!--导入-->
    <infoImport
      :visiable="diaInfoVisiable"
      :left-data="leftData"
      :all-role-list="allRoleList"
      @dialogHide="dialogHide"
    />
    <!--编辑-->
    <el-dialog
      center
      :close-on-click-modal="false"
      :visible.sync="infoDialogVisiable"
      width="45%"
    >
      <div slot="title" class="title">编辑消息</div>
      <div class="proInfo">
        <el-row class="row">
          <el-col :span="4" class="left">通知名称：</el-col>
          <el-col :span="20">
            <el-input v-model="name" type="text" size="mini" />
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="4" class="left">通知方法：</el-col>
          <el-col :span="20">
            <el-select v-model="method" multiple collapse-tags size="mini">
              <el-option
                v-for="(item, a) in methodList"
                :key="a"
                :label="item.name"
                :value="item.name"
              />
            </el-select>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="4" class="left">通知角色：</el-col>
          <el-col :span="20">
            <el-row v-for="(item, index) in unit" :key="index">
              <el-col :span="10">
                <el-select
                  v-model="unit[index]"
                  placeholder="请选择"
                  size="mini"
                >
                  <el-option
                    v-for="(item, i) in unitList"
                    :key="i"
                    :label="item.name"
                    :value="item.name"
                  />
                </el-select>
              </el-col>
              <el-col :span="10">
                <el-select
                  v-model="role[index]"
                  placeholder="请选择"
                  size="mini"
                >
                  <el-option
                    v-for="(item, e) in allRoleList"
                    :key="e"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-col>
              <el-col :span="4">
                <div class="left" style="text-align: center; line-height: 32px">
                  <img
                    src="../../assets/avatar/add.png"
                    alt="增加"
                    width="15px;"
                    style="margin-right: 13px"
                    @click="add"
                  />
                  <img
                    v-if="unit.length > 1"
                    src="../../assets/avatar/reduce.png"
                    alt="增加"
                    width="15px;"
                    @click="delExper(index)"
                  />
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          size="mini"
          @click="updateInfo"
          v-preventReClick
          >确 定</el-button
        >
        <el-button size="mini" @click="cancel">取 消</el-button>
      </span>
    </el-dialog>
        <!--编辑-->
        <el-dialog
      center
      :close-on-click-modal="false"
      :visible.sync="infoDialogVisiable2"
      width="40%"
    >
      <div slot="title" class="title">服务时长配置</div>
      <div class="proInfo">
        <el-row class="row">
          <el-col :span="4" class="left">系统服务时长：</el-col>
          <el-col :span="20">
            <el-input v-model="name" type="number" size="mini" placeholder="请输入该项目系统服务时长月份">
              <template slot="append">月</template>
            </el-input>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="5" class="left">首次临期提醒时间：</el-col>
          <el-col :span="19">
            <el-input v-model="name" type="number" size="mini" placeholder="请输入首次临期到期提醒时间">
              <template slot="append">月</template>
            </el-input>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="5" class="left">首次临期提醒内容：</el-col>
          <el-col :span="19">
            <el-input v-model="name" type="textarea" placeholder="请输入首次临期到期提醒内容">
            </el-input>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="5" class="left">二次临期提醒时间：</el-col>
          <el-col :span="19">
            <el-input v-model="name" type="number" size="mini" placeholder="请输入二次临期到期提醒时间">
              <template slot="append">月</template>
            </el-input>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="5" class="left">二次临期提醒内容：</el-col>
          <el-col :span="19">
            <el-input v-model="name" type="textarea" placeholder="请输入二次临期到期提醒内容">
            </el-input>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          size="mini"
          @click="updateInfo2"
          v-preventReClick
          >确 定</el-button
        >
        <el-button size="mini" @click="cancel2">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getInfoList,
  importInfos,
  delInfo,
  editInfo,
  detailInfo,
} from "@/api/info";
import { roleListNo } from "@/api/roleModel";
import { getProjectId } from "@/utils/auth";
import infoImport from "./component/infoImport";
export default {
  name: "Info",
  components: {
    infoImport,
  },
  data() {
    return {
      timer:"",
      cellStyle: {
        textAlign: "center",
      },
      currentPage: 1,
      pageSize: 10,
      total: null,
      infoData: [],
      key: "",
      proId: "",
      diaInfoVisiable: false,
      leftData: [],
      leftDataName: [],
      leftDataMethod: [],
      allRoleList: [],
      infoDialogVisiable: false,
      infoDialogVisiable2: false,
      unit: [],
      unitList: [
        { name: "关联单位" },
        { name: "所有单位" },
        { name: "申办方" },
      ],
      role: [],
      name: "",
      method: "",
      infoId: "",
      methodList: [{ name: "站内通知" }, { name: "邮件通知" }],
      loading: false,
    };
  },
  computed: {
    pinjie() {
      return function (val) {
        let arr = [];
        val.map((item) => {
          console.log(item);
          arr = arr.concat(item.unit_type + " " + item.role_str);
        });
        console.info(arr.join("、"));
        return arr.join("、");
      };
    },
    pinjieMethod() {
      return function (val) {
        return val.join("、");
      };
    },
  },
  watch: {
    key(value) {
      if (this.timer !== null) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.getInfoList, 500);
    },
  },
  created() {
    this.proId = getProjectId();
    this.getInfoList();
    this.getRoleList();
  },
  methods: {
    add() {
      this.unit.push("");
    },
    delExper(index) {
      this.unit.splice(index, 1);
      this.role.splice(index, 1);
    },
    // 所有角色
    getRoleList() {
      roleListNo({ project_id: this.proId })
        .then((res) => {
          if (res && res.code === 0) {
            if (res.data && res.data.length > 0) {
              this.allRoleList = res.data.map((item) => {
                return item.name;
              });
              this.allRoleList.push("被创建者", "所有用户", "操作者");
              console.log(78789);
              console.log(this.allRoleList);
            } else {
              this.allRoleList = [];
            }
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    getInfos() {
      importInfos({ project_id: this.proId })
        .then((res) => {
          if (res && res.code === 0) {
            if (res.data && res.data.length > 0) {
              console.log("左边");
              console.log(this.leftData);
              this.leftData = res.data;
              // this.leftData = res.data.map(item => {
              //   const obj = {}
              //   obj.name = item.name
              //   return obj
              // })
              console.log(this.leftData);
            } else {
              this.leftData = [];
            }
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    dialogHide() {
      this.diaInfoVisiable = false;
    },
    handelInfo() {
      this.diaInfoVisiable = true;
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      // 改表头颜色
      if (rowIndex === 0) {
        return "background-color: #D6E4FF;color: #595959;text-align:center;";
      }
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getInfoList();
    },
    // 当前页数
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getInfoList();
    },
    getInfoList() {
      this.loading = true;
      const params = {
        project_id: this.proId,
        key: this.key,
        page: this.currentPage - 1,
        page_size: this.pageSize,
      };
      getInfoList(params)
        .then((res) => {
          if (res && res.code === 0) {
            this.loading = false;
            if (res.data && res.data.length > 0) {
              this.infoData = res.data;
              this.total = res.total;
            } else {
              this.infoData = [];
            }
            this.getInfos();
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    deleteInfo(row) {
      this.$confirm(
        `是否确认删除通知 <span style="color: #698CFC;font-size: 14px;font-weight: bold;">${row.name} </span>?`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          cancelButtonClass: "btn-custom-cancel",
          type: "warning",
        }
      )
        .then(() => {
          const params = {
            id: row.id,
            project_id: this.proId,
          };
          delInfo(params)
            .then((res) => {
              if (res && res.code === 0) {
                this.$message({
                  message: res.msg,
                  type: "success",
                });
                this.getInfoList();
              } else {
                this.$message(res.msg);
              }
            })
            .catch((res) => {
              console.log(res.msg);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    editInfo(row) {
      this.infoId = row.id;
      this.infoDialogVisiable = true;
      const params = {
        project_id: this.proId,
        id: row.id,
      };
      this.unit = [];
      this.role = [];

      detailInfo(params)
        .then((res) => {
          if (res && res.code === 0) {
            if (res.data && res.data.receiver_role_list.length > 0) {
              this.name = res.data.name;
              this.method = res.data.method;
              res.data.receiver_role_list.map((item) => {
                this.unit.push(item.unit_type);
                this.role.push(item.role_str);
              });
            }
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    updateInfo() {
      const array = [];
      this.unit.map((item, index) => {
        this.role.map((items, i) => {
          if (index === i) {
            const objs = {};
            objs.unit_type = item;
            objs.role_str = items;
            array.push(objs);
            console.log(objs);
          }
        });
      });
      console.log(array);
      const params = {
        project_id: this.proId,
        name: this.name,
        method: this.method,
        id: this.infoId,
      };
      params.receiver_role_list = array;
      editInfo(params)
        .then((res) => {
          if (res && res.code === 0) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.cancel();
            this.getInfoList();
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    updateInfo2(){

    },
    cancel() {
      this.name = "";
      this.method = "";
      this.unit = [];
      this.role = [];
      this.infoDialogVisiable = false;
    },
    onClick(){
      this.infoDialogVisiable2 = true;
    },
    cancel2(){
      this.infoDialogVisiable2 = false;
    }
  },
};
</script>

<style scoped>
img{
  cursor: pointer;
}
.btn {
  text-align: right;
}
.container-table {
  margin-top: 20px;
}
.title {
  padding: 15px 0;
  background-color: #d6e4ff;
  color: #595959;
  font-weight: 500;
  font-size: 16px;
}
.proInfo {
  background-color: #f0f5ff;
  padding: 20px 30px;
}
.row {
  margin: 20px 0;
  font-size: 14px;
  color: #595959;
}
.left {
  line-height: 26px;
}
.pages {
  margin-top: 30px;
  text-align: right;
}
.edit {
  font-size: 12px;
  margin-right: 10px;
}
</style>
<style>
.el-dialog__header {
  padding: 0px;
}
.container-table {
  border: 1px solid #e5eeff;
}
.el-tooltip__popper.is-light {
  border: none;
  background: #ffffff;
  box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08),
    -1px -1px 12px 0px rgba(0, 0, 0, 0.12);
}
.popper__arrow {
  border: none !important;
}

.btn-custom-cancel {
  float: right;
  margin-left: 10px;
}
.el-table__column-filter-trigger i {
  color: #000;
  font-size: 14px;
}
.diaBg {
  background-color: #f0f5ff;
  padding: 20px;
}
</style>
